import { Button } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import CustomTextField from '../../form-controls/custom-text-field/Custom-Text-Field';
import BackgroundColor from '../background-color/BackgroundColor';
import './Hyperlink.scss';
import { formDataValidate } from '../../../utils/formUtils';

const Hyperlink = (props) => {
  const { formData, setFormData } = props;
  const [isHyperLink, setIsHyperLink] = useState(false);
  const [hyperlinkList, setHyperlinkList] = useState([]);
  const [linkData, setLinkData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    textColor: {
      value: '#00B1FF',
      fieldName: 'Hex',
      errors: {},
      validations: [],
      tab: 0,
    },
    text: {
      value: '',
      fieldName: 'Text to display',
      errors: {},
      validations: [],
      placeholder: 'Here',

      tab: 0,
    },
    url: {
      value: '',
      fieldName: 'Address',
      errors: {},
      validations: [],
      placeholder: 'Enter URL',
      tab: 0,
    },
  });

  const setDefaultValue = (isLinkActive) => {
    const currLinkData = { ...linkData };
    currLinkData.textColor.value = '#00B1FF';
    currLinkData.text.value = '';
    currLinkData.text.validations = isLinkActive ? ['required'] : [];
    currLinkData.url.value = '';
    currLinkData.url.validations = isLinkActive ? ['required', 'validUrl', 'safeDomain'] : [];
    setLinkData(currLinkData);
  };

  useEffect(() => {
    if (formData.hyperLink.value.length > 0) {
      setHyperlinkList([...formData.hyperLink.value]);
      setIsHyperLink(true);
    }
  }, [formData.hyperLink.value]);

  const onClickHyperLink = () => {
    setDefaultValue(!isHyperLink);
    setIsHyperLink(!isHyperLink);
    setHyperlinkList([]);
    setFormData({
      hyperLink: { ...formData.hyperLink, value: [] },
    });
  };

  const validate = () => {
    const isValid = formDataValidate(linkData, false);
    return !isValid;
  };

  const onAddLink = () => {
    if (!linkData.textColor.value || !linkData.text.value || !linkData.url.value) return false;
    const currHyperlinkList = [...hyperlinkList];
    const linkNdx = currHyperlinkList.findIndex((link) => link.text === linkData.text.value);
    if (linkNdx > -1) {
      currHyperlinkList[linkNdx].text = linkData.text.value;
      currHyperlinkList[linkNdx].textColor = linkData.textColor.value;
      currHyperlinkList[linkNdx].url = linkData.url.value;
    } else
      currHyperlinkList.push({
        text: linkData.text.value,
        textColor: linkData.textColor.value,
        url: linkData.url.value,
      });
    setHyperlinkList(currHyperlinkList);
    setFormData({
      hyperLink: {
        ...formData.hyperLink,
        value: currHyperlinkList,
      },
    });
    setDefaultValue();
  };

  return (
    <div className='hyperlink'>
      <p
        onClick={() => onClickHyperLink()}
        className={!isHyperLink ? 'hyperlink-title-default' : 'hyperlink-title'}
      >
        Add Hyperlink{' '}
        {!isHyperLink && (
          <span className='hyperlink-attach-icon'>
            <InsertLinkIcon />
          </span>
        )}
      </p>
      {isHyperLink && (
        <>
          <BackgroundColor
            formData={linkData}
            setFormData={setLinkData}
            title='Link Text Color'
            fieldKey='textColor'
            defaultColor='#00B1FF'
          />
          <div className='mt-3'>
            <CustomTextField
              item={linkData.text}
              handleInputChange={(e) => {
                setLinkData({ text: e });
              }}
            />
          </div>
          <div className='mt-4'>
            <CustomTextField
              item={linkData.url}
              handleInputChange={(e) => {
                setLinkData({ url: e });
              }}
            />
          </div>
          <div className='mt-4 add-btn-rapper'>
            <Button
              variant='outlined'
              color='primary'
              type='button'
              className='add-btn'
              onClick={() => onAddLink()}
              disabled={validate()}
            >
              Add
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Hyperlink;
